import React from "react";
import NavBar from "../components/NavBar";
import NurseryPrimaryComponent from "../components/NurseryPrimaryComponent";
import Footer from "../components/Footer";

const NurseryPrimary = () => {
    return(
        <div className="main-container">
            <NavBar/>
            <NurseryPrimaryComponent/>
            <Footer/>
        </div>
    )
}
export default NurseryPrimary